"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseValidator2 = _interopRequireDefault(require("./BaseValidator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// import {pushleads_mapping} from "../mappings/OneMktoMapping";
var InteractionOnlyValidator =
/*#__PURE__*/
function (_BaseValidator) {
  _inherits(InteractionOnlyValidator, _BaseValidator);

  function InteractionOnlyValidator() {
    var _this;

    var mkto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "legacy";

    _classCallCheck(this, InteractionOnlyValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InteractionOnlyValidator).call(this, "InteractionOnly", mkto, false));
    var company = mkto === "legacy" ? "company" : "Company_Self_Reported__c";
    _this.required = ["country", "lastName", "leadStatus", company].concat(_toConsumableArray(_this.required));
    _this.props = {
      "leadStatus": {
        "type": "string",
        "enum": ["I"],
        "error": "'leadStatus' must be 'I' for lead type '".concat(_this.type, "'.")
      },
      "InteractionStage": {
        "oneOf": [{
          "type": "string",
          enum: ["2"]
        }, {
          "type": "integer",
          enum: [2]
        }],
        "error": "'InteractionStage' must be '2' for lead type '".concat(_this.type, "'.")
      }
    };

    _this._init();

    return _this;
  }

  return InteractionOnlyValidator;
}(_BaseValidator2.default);

exports.default = InteractionOnlyValidator;
//# sourceMappingURL=InteractionOnlyValidator.js.map